export default "__VITE_ASSET__CKHNoo47__"